import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ADD_SELECTOR } from "../../../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../../../base/base.component";
import { AppComponent } from "../../../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { GenericService } from "../../../../../crossconcern/services/generic.services";
import { AlertUtils } from "../../../../../crossconcern/utilities/utils/alert.utils";
import { FormInfoField } from "../../../../../crossconcern/models/form/forminfofield";
import {
    ADD_MODE,
    FORM_TYPE_CHECKBOX,
    FORM_TYPE_TEXT,
    FORM_WIDTH_COL_4,
    FORM_WIDTH_OFFSET_COL_0
} from "../../../../../crossconcern/utilities/properties/base.property";
import { Validators } from "@angular/forms";
import { FormInfo } from "../../../../../crossconcern/models/form/forminfo";
import { Subscription } from "rxjs";
import { PRIVATE_NURSERY_LIST_ROUTE } from "../../../../../crossconcern/utilities/properties/routename.property";
import { finalize } from "rxjs/operators";
import { IDropdownSettings } from "ng-multiselect-dropdown/multiselect.model";
import { NurseryManager } from "app/business/managers/nursery.manager";
import { NurseryModel } from "app/datastore/entities/nursery.model";

@Component({
    selector: ADD_SELECTOR,
    templateUrl: "../detail/nurserydetail.component.html"
})
export class NurseryNewComponent extends BaseComponent implements OnInit, OnDestroy {

    public nursery: NurseryModel;
    public formInfo: FormInfo;
    public selectedFiles: FileList[] = [];

    @ViewChild("formNursery", null) private formComponent;

    public dropdownSettings: IDropdownSettings;

    private onGoBackCalledSubscription: Subscription;

    public titleText = "NURSERY_NEW_COMPONENT_LABEL";

    public imageURL: string = null;
    public mode = ADD_MODE;

    public sphereLoadingVisible: boolean;
    public currentLoading: string;

    constructor(
        protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        protected genericService: GenericService,
        private nurseryManager: NurseryManager,
        private activeRoute: ActivatedRoute,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
        this.dropdownSettings = {
            singleSelection: false,
            idField: "id",
            textField: "text",
            enableCheckAll: false,
            allowSearchFilter: true
        };

        const formInfoFields: FormInfoField[] = [
            new FormInfoField(
                FORM_TYPE_TEXT,
                "NURSERY_DETAIL_COMPONENT_NAME",
                "name",
                [
                    Validators.required
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(
                FORM_TYPE_TEXT,
                "NURSERY_DETAIL_COMPONENT_ADDRESS",
                "address",
                [
                    Validators.required
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(
                FORM_TYPE_TEXT,
                "NURSERY_DETAIL_COMPONENT_LAT",
                "latitude",
                [
                    Validators.required,
                    Validators.pattern("[0-9]+([.][0-9]+)?")
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(
                FORM_TYPE_TEXT,
                "NURSERY_DETAIL_COMPONENT_LONG",
                "longitude",
                [
                    Validators.required,
                    Validators.pattern("[0-9]+([.][0-9]+)?")
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(
                FORM_TYPE_TEXT,
                "NURSERY_DETAIL_COMPONENT_VERSION_NUMBER",
                "versionNumber",
                [
                    Validators.required
                ],
                null,
                null,
                null,
                true,
                true,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(
                FORM_TYPE_CHECKBOX,
                "NURSERY_DETAIL_COMPONENT_VISIBLE",
                "visible",
                [],
                null,
                null,
                true,
                true,
                false,
                null,
                FORM_WIDTH_COL_4,
                FORM_WIDTH_OFFSET_COL_0)
        ];

        this.formInfo = new FormInfo(formInfoFields, null);

        this.subscribeGenericServices();
    }

    public ngOnInit(): void {
        /*
        nothing
        */
    }

    public onFilesSelected(event) {
        this.selectedFiles = event;
    }

    public ngOnDestroy() {
        this.unsubscribeServices();
    }

    public onSaveNursery() {
        this.appComponent.startLoading();

        this.nurseryManager.addNursery(
            {
                "name": this.formComponent.form.value.name,
                "address": this.formComponent.form.value.address,
                "latitude": this.formComponent.form.value.latitude,
                "longitude": this.formComponent.form.value.longitude,
                "visible": (this.formComponent.form.value.visible === null) ? false : this.formComponent.form.value.visible,
                "version_number": this.formComponent.form.value.versionNumber
            })
            .pipe(
                finalize(() => this.appComponent.stopLoading())
            )
            .subscribe({
                complete: () => this.goToRouteByName(PRIVATE_NURSERY_LIST_ROUTE)
            });
    }

    private subscribeGenericServices() {
        this.onGoBackCalledSubscription = this.genericService.onGoBackCalled.subscribe(() => {
            this.goToRouteByName(PRIVATE_NURSERY_LIST_ROUTE);
        });
    }

    private unsubscribeServices() {
        if(this.onGoBackCalledSubscription) {
            this.onGoBackCalledSubscription.unsubscribe();
        }
    }

}